/**
 * Check if draggable marker should be disabled for POI editing
 * @param {string} currentPage - Current page pathname
 * @param {Object} poiCreator - POI creator object with UserID
 * @param {Object} authData - Auth data from UserContext
 * @param {Array} authData.userGroups - User's groups
 * @param {Object} authData.user - Current user object with UserID
 * @returns {boolean}
 */
export const isDraggableMarkerDisabled = (currentPage, poiCreator, { userGroups, user }) => {
    //if on poi-edit page, can edit as long as POI creator or admin
    if(currentPage.includes("poi-edit") &&
      (user?.UserID === poiCreator?.UserID || userGroups?.includes("Admin"))
    ){
        return false
    }

    //if not on poi-edit page, not allowed to edit POIs
    return true
}

/**
 * Check if POI editing is disabled
 * @param {string} currentPage - Current page pathname
 * @param {Object} selectedPoiGroup - Selected POI group with label
 * @param {Object} poiCreator - POI creator object with UserID
 * @param {Object} authData - Auth data from UserContext
 * @param {Array} authData.userGroups - User's groups
 * @param {Object} authData.user - Current user object with UserID
 * @param {boolean} isEditor - Whether user is an editor of the group
 * @returns {boolean}
 */
export const isPoiEditDisabled = (currentPage, selectedPoiGroup, poiCreator, { userGroups, user }, isEditor = false) => {
  const fetchedByGroup = !selectedPoiGroup.label.includes("All POIs")

  // in group view, only care if user is a group editor or admin
  if(currentPage.includes("poi-edit") && fetchedByGroup &&
    (userGroups?.includes("Admin") || isEditor)
  ){
    return false
  }

  //if not in group view, can edit if admin or poi creator
  if(currentPage.includes("poi-edit") && !fetchedByGroup &&
    (userGroups?.includes("Admin") || user?.UserID === poiCreator?.UserID)
  ){
    return false
  }

  //if not on poi-edit page, not allowed to edit POIs
  return true
}

/**
 * Check if user is an admin
 * @param {Array} userGroups - User's groups from UserContext
 * @returns {boolean}
 */
export const isUserAdmin = (userGroups) => {
  return userGroups?.includes('Admin') ?? false
}
